// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/atrapame-si-puedes/atrapame-si-puedes.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asp-container-wrapper {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      top center no-repeat,
    #2b363b;
  background-position: top center;
  background-repeat: no-repeat;

  background-attachment: scroll;
  background-size: 100% auto;
  min-height: 100vh;
}

.asp-container {
  position: relative;
  padding: 40px 20px 25px;
  box-sizing: border-box;
  z-index: 1;
}

.asp-header {
  position: absolute;
}
.asp-header-content {
  display: flex;
  gap: 45px;
}

.asp-card-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 130vw;
}

.asp-header-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px; /* ajustá según necesites */
}

.asp-back-arrow {
  position: absolute;
  left: 0;
  width: 60px; /* espacio reservado para la flecha */
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.asp-title-header {
  font-size: 24px;
  font-weight: bold;
  font-family: "Red Hat Display", Sans-serif;
  color: #fff;
}

/* Card */
.asp-promo-card {
  background: #f0f0f0;
  border-radius: 16px;
  padding: 2rem 0.56rem;
  max-width: 360px;
  width: 100%;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.asp-loading-container {
  display: flex;
  min-height: 12rem;
  align-items: center;
  justify-content: center;
}
.asp-card-icon {
  width: 4.1875rem;
  height: 3.75rem;
  aspect-ratio: 67/60;
  margin-bottom: 0.75rem;
}
.asp-card-icon-take {
  width: 3.4375rem;
  height: 3.4375rem;
  aspect-ratio: 1/1;
  margin-bottom: 0.75rem;
}
.asp-card-icon-social-media {
  width: 2rem;
  height: 2rem;
  aspect-ratio: 1/1;
  cursor: pointer;
}
.asp-card-logos-container {
  display: flex;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}
.asp-card-title {
  color: #da0d29;
  text-align: center;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin-bottom: 0.75rem;
}

.asp-card-text-container {
  margin-bottom: 1.25rem;
}

.asp-card-text {
  color: #2b363b;
  text-align: center;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 1.375rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.asp-card-text-bold {
  font-weight: bold;
}

.asp-card-button {
  border-radius: 0.5rem;
  background: #da0d29;
  color: #ffffff;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;

  display: flex;
  height: 3.5rem;
  padding: 0.625rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  border: none;
  margin-bottom: 0.5rem;
}

.asp-card-button:disabled {
  background: rgba(43, 54, 59, 0.25);
}

.asp-card-terms {
  color: var(--Gunmetal-75, rgba(43, 54, 59, 0.75));
  text-align: center;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.asp-card-terms-span {
  color: #da0d29;
  text-decoration: underline;
  cursor: pointer;
}

/* MODAL */

.asp-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 75%;
  height: auto;
  max-height: 60%;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  border-radius: 8px;
  outline: none;
  padding: 5vh 2vh 2vh 2vh;
  justify-content: space-around;
  overflow-x: hidden;
  padding: 1.875rem 1.25rem;
}

.asp-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 2;
}

.asp-modal-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  align-items: center;
  justify-content: center;
}

.asp-modal-container-top {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}
.asp-modal-container-top-card-icon-hand {
  width: 4.1875rem;
  height: 3.75rem;
}

.asp-modal-container-top-title-text {
  color: #2b363b;
  text-align: center;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.asp-modal-container-text {
  color: #2b363b;
  text-align: center;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

p strong {
  color: #2b363b;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.9375rem;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
}

.asp-modal-buttons-container {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.asp-modal-buttons-container-close {
  background: #da0d29;
  border-radius: 0.5rem;
  width: 100%;
  color: #fff;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  height: 3rem;
  display: flex;
  padding: 0.625rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  border: none;
}

.asp-modal-buttons-container-bonificaciones {
  border-radius: 0.5rem;
  border: 1px solid var(--Amaranth-Red-100, #da0d29);
  width: 100%;
  color: #da0d29;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  height: 3rem;
  padding: 0.625rem;
  justify-content: center;
  align-items: center;
  font-family: "Red Hat Display", Sans-serif;
  height: 3rem;
  display: flex;
  padding: 0.625rem;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
}

.asp-modal-terms {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 8px;
  outline: none;
  justify-content: space-around;
  padding: 1.875rem 1.25rem;
  width: 75%;
}

.asp-modal-terms-close {
  position: absolute;
  right: 0.85rem;
  top: 0.75rem;
  cursor: pointer;
  width: 1rem;
  height: 1rem;
}

.asp-modal-terms-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  overflow-y: auto;
  max-height: 60vh;
  padding-right: 0.75rem; /* para dejar espacio al scroll si es necesario */
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.asp-modal-terms-container-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.75rem;
}

.asp-modal-terms-title {
  color: #2b363b;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.asp-modal-terms-container-text {
  color: #2b363b;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.asp-modal-terms-container-text strong {
  color: #2b363b;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}

.asp-modal-term-container-list {
  list-style: none;
  padding: 0;
}
.asp-modal-term-container-list li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  color: #2b363b;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
.asp-modal-term-container-list .asp-modal-terms-container-list-number {
  color: #2b363b;
  margin: 0;
  font-family: "Red Hat Display", Sans-serif;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
`, "",{"version":3,"sources":["webpack://./src/qr/atrapameSiPuedes.css"],"names":[],"mappings":"AAAA;EACE;;WAES;EACT,+BAA+B;EAC/B,4BAA4B;;EAE5B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAE,2BAA2B;AAC3C;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW,EAAE,qCAAqC;EAClD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0CAA0C;EAC1C,WAAW;AACb;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;;EAEnB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;EAClD,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB,EAAE,iDAAiD;EACzE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,SAAS;EACT,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".asp-container-wrapper {\n  background: url(\"../assets/images/atrapame-si-puedes/atrapame-si-puedes.png\")\n      top center no-repeat,\n    #2b363b;\n  background-position: top center;\n  background-repeat: no-repeat;\n\n  background-attachment: scroll;\n  background-size: 100% auto;\n  min-height: 100vh;\n}\n\n.asp-container {\n  position: relative;\n  padding: 40px 20px 25px;\n  box-sizing: border-box;\n  z-index: 1;\n}\n\n.asp-header {\n  position: absolute;\n}\n.asp-header-content {\n  display: flex;\n  gap: 45px;\n}\n\n.asp-card-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 130vw;\n}\n\n.asp-header-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 20px; /* ajustá según necesites */\n}\n\n.asp-back-arrow {\n  position: absolute;\n  left: 0;\n  width: 60px; /* espacio reservado para la flecha */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.asp-title-header {\n  font-size: 24px;\n  font-weight: bold;\n  font-family: \"Red Hat Display\", Sans-serif;\n  color: #fff;\n}\n\n/* Card */\n.asp-promo-card {\n  background: #f0f0f0;\n  border-radius: 16px;\n  padding: 2rem 0.56rem;\n  max-width: 360px;\n  width: 100%;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.asp-loading-container {\n  display: flex;\n  min-height: 12rem;\n  align-items: center;\n  justify-content: center;\n}\n.asp-card-icon {\n  width: 4.1875rem;\n  height: 3.75rem;\n  aspect-ratio: 67/60;\n  margin-bottom: 0.75rem;\n}\n.asp-card-icon-take {\n  width: 3.4375rem;\n  height: 3.4375rem;\n  aspect-ratio: 1/1;\n  margin-bottom: 0.75rem;\n}\n.asp-card-icon-social-media {\n  width: 2rem;\n  height: 2rem;\n  aspect-ratio: 1/1;\n  cursor: pointer;\n}\n.asp-card-logos-container {\n  display: flex;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n.asp-card-title {\n  color: #da0d29;\n  text-align: center;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 1.5rem;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n  margin-bottom: 0.75rem;\n}\n\n.asp-card-text-container {\n  margin-bottom: 1.25rem;\n}\n\n.asp-card-text {\n  color: #2b363b;\n  text-align: center;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 1.375rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.asp-card-text-bold {\n  font-weight: bold;\n}\n\n.asp-card-button {\n  border-radius: 0.5rem;\n  background: #da0d29;\n  color: #ffffff;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.85rem;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n\n  display: flex;\n  height: 3.5rem;\n  padding: 0.625rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.625rem;\n  align-self: stretch;\n  border: none;\n  margin-bottom: 0.5rem;\n}\n\n.asp-card-button:disabled {\n  background: rgba(43, 54, 59, 0.25);\n}\n\n.asp-card-terms {\n  color: var(--Gunmetal-75, rgba(43, 54, 59, 0.75));\n  text-align: center;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.asp-card-terms-span {\n  color: #da0d29;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* MODAL */\n\n.asp-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 75%;\n  height: auto;\n  max-height: 60%;\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  border-radius: 8px;\n  outline: none;\n  padding: 5vh 2vh 2vh 2vh;\n  justify-content: space-around;\n  overflow-x: hidden;\n  padding: 1.875rem 1.25rem;\n}\n\n.asp-modal-overlay {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n  z-index: 2;\n}\n\n.asp-modal-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.asp-modal-container-top {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n.asp-modal-container-top-card-icon-hand {\n  width: 4.1875rem;\n  height: 3.75rem;\n}\n\n.asp-modal-container-top-title-text {\n  color: #2b363b;\n  text-align: center;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 1.25rem;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n}\n\n.asp-modal-container-text {\n  color: #2b363b;\n  text-align: center;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.9375rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n}\n\np strong {\n  color: #2b363b;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.9375rem;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 140%;\n}\n\n.asp-modal-buttons-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n\n.asp-modal-buttons-container-close {\n  background: #da0d29;\n  border-radius: 0.5rem;\n  width: 100%;\n  color: #fff;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n  height: 3rem;\n  display: flex;\n  padding: 0.625rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.625rem;\n  align-self: stretch;\n  border: none;\n}\n\n.asp-modal-buttons-container-bonificaciones {\n  border-radius: 0.5rem;\n  border: 1px solid var(--Amaranth-Red-100, #da0d29);\n  width: 100%;\n  color: #da0d29;\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n  height: 3rem;\n  padding: 0.625rem;\n  justify-content: center;\n  align-items: center;\n  font-family: \"Red Hat Display\", Sans-serif;\n  height: 3rem;\n  display: flex;\n  padding: 0.625rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.625rem;\n  align-self: stretch;\n}\n\n.asp-modal-terms {\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 8px;\n  outline: none;\n  justify-content: space-around;\n  padding: 1.875rem 1.25rem;\n  width: 75%;\n}\n\n.asp-modal-terms-close {\n  position: absolute;\n  right: 0.85rem;\n  top: 0.75rem;\n  cursor: pointer;\n  width: 1rem;\n  height: 1rem;\n}\n\n.asp-modal-terms-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  overflow-y: auto;\n  max-height: 60vh;\n  padding-right: 0.75rem; /* para dejar espacio al scroll si es necesario */\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.asp-modal-terms-container-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.75rem;\n}\n\n.asp-modal-terms-title {\n  color: #2b363b;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 900;\n  line-height: normal;\n}\n\n.asp-modal-terms-container-text {\n  color: #2b363b;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n\n.asp-modal-terms-container-text strong {\n  color: #2b363b;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n\n.asp-modal-term-container-list {\n  list-style: none;\n  padding: 0;\n}\n.asp-modal-term-container-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  color: #2b363b;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n.asp-modal-term-container-list .asp-modal-terms-container-list-number {\n  color: #2b363b;\n  margin: 0;\n  font-family: \"Red Hat Display\", Sans-serif;\n  font-size: 0.8125rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
